import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'

import EnrichApiUsageOverview from './views/EnrichApiUsageOverview'

export default [routeWithLayout({ main: EnrichApiUsageOverview, path: UrlProvider.getRawUrl('enrich') })]
